module.exports = __webpack_public_path__ + "img/uretim-kapasite.f496ace7.png";